import { Localize } from "components/service";
import { Link } from "react-router-dom";
import GraphicStandFields from "../fields";
import StandFields from "components/stands/fields";
import GraphicStorage from "components/graphic-storage";

const graphicWarehouseColumns = [
    {
        title: <Localize>TABLES.Column_Title_Exhibitor</Localize>,
        dataIndex: 'exhibitor',
        columnIndex: 'EXHIBITOR',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_ExhibitionEvent</Localize>,
        dataIndex: 'exhibitionEvent',
        columnIndex: 'EE_ID',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Block</Localize>,
        dataIndex: 'block',
        columnIndex: 'BLOCK',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Stands</Localize>,
        dataIndex: 'stand',
        columnIndex: 'STAND_NUMBER',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Shelf</Localize>,
        dataIndex: 'shelfNo',
        columnIndex: 'SHELF_NUMBER',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_ShelfDate</Localize>,
        dataIndex: 'shelf_date_at',
        columnIndex: 'SHELF_DATE_AT',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_ShelfUser</Localize>,
        dataIndex: 'shelf_user',
        columnIndex: 'SHELF_USER_ID',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Materials</Localize>,
        dataIndex: 'materials',
        columnIndex: 'MATERIALS',
    },
    {
        title: <Localize>TABLES.Column_Title_Actions</Localize>,
        dataIndex: 'action',
        columnIndex: 'ACTIONS',
        align: 'center',
        width: 60,
    },
];

const graphicWarehouseData = (stands, currentObj) => {
    if (!stands)
    {
        return [];
    }

    return stands
        // .filter(stand => stand.shelf_number && stand.shelf_number.trim() !== '')
        .map((stand) => {
            return {
                key: stand.id,
                id: stand.id,
                exhibitor: (
                    // <Link to={ `${ Event.Const.basePath }/${ stand.exhibitionEvent?.id }/stands/${ stand.id }` }>
                     <strong style={{ color: 'white' }}>   { stand.exhibitor || <strong>&mdash;</strong> }</strong>
                    // </Link>
                ),
                exhibitionEvent: (
                    <Link to={ `${ GraphicStorage.Const.basePath }/${ stand.exhibitionEvent?.id }/graphics` }>
                        { stand.exhibitionEvent?.title || <strong>&mdash;</strong> }
                    </Link>
                ),
                block: stand.block || <strong>&mdash;</strong>,
                stand: stand.stand_number || <strong>&mdash;</strong>,
                shelfNo: <GraphicStandFields.Shelf stand={stand} />,
                shelf_date_at: <StandFields.ShelfDate date={ stand.shelf_date_at } />,
                shelf_user: <StandFields.ShelfUser user={ stand.relShelfUser } />,
                materials: <GraphicStandFields.Graphic stand={ stand } />,
                action: <GraphicStandFields.WarehouseAction craftData={ stand.relCraftCollectGraphic } stand={ stand } />,
            };
        });
};

const GraphicWarehouseTableHelper = {
    columns: graphicWarehouseColumns,
    data: graphicWarehouseData,
};

export default GraphicWarehouseTableHelper;
